import React from "react"

import { Element, Image } from "legacy/components/shared/base"
import { getTextPadding } from "./helpers"
import { ImageAndTextItemType } from "types/shared-components"
import { Maybe } from "types/Maybe"
import TextElements from "../TextElements"

interface OwnProps {
  data: Maybe<ImageAndTextItemType>
  imageStartsOn: Maybe<string>
  indexIsEven: boolean
}

export type ImageAndTextProps = OwnProps

const ImageAndText: React.FC<ImageAndTextProps> = ({
  data,
  imageStartsOn,
  indexIsEven,
}): React.ReactElement | null => {
  if (!data) return null
  const { height, width } = data?.image?.dimensions || {}
  const textPadding = getTextPadding(imageStartsOn, indexIsEven)

  return (
    <>
      <Element
        alignItems="center"
        alignSelf="center"
        gridArea="img"
        overflow="hidden"
      >
        <Element height="100%" m="0 auto" width="100%" overflow="hidden">
          <Image
            aspectRatio={`${width} / ${height}`}
            display="block"
            imageData={data.image}
            maxWidth="100%"
            width={["639px", "600px", "512px", "720px"]}
          />
        </Element>
      </Element>
      <TextElements data={data} textPadding={textPadding} />
    </>
  )
}

export default ImageAndText
